// @flow
import {handleActions, combineActions} from 'redux-actions';

import {CATEGORY} from 'constants/actions';
import {scrollCTPafterMyFit} from 'features/myFit/reducers/myFit';

import type {ActiveFiltersReducerStateType} from './activeFiltersType';

export const initialState: ActiveFiltersReducerStateType = {
    isDirty: false,
};

// $FlowFixMe
export const activeFilters = handleActions(
    {
        /**
         * CATEGORY.GET_STATE_FILTER action handler
         * @param {ActiveFiltersReducerStateType} state - current state
         * @return {ActiveFiltersReducerStateType} new state
         */
        [CATEGORY.GET_STATE_FILTER]: (
            state: ActiveFiltersReducerStateType,
        ): ActiveFiltersReducerStateType => ({
            ...state,
            isDirty: false,
        }),

        /**
         * CATEGORY.CHANGED_FILTER action handler
         * @param {ActiveFiltersReducerStateType} state - current state
         * @return {ActiveFiltersReducerStateType} new state
         */
        [combineActions(
            CATEGORY.CHANGED_FILTER,
            CATEGORY.GET_ACTIVE_SORT,
            CATEGORY.REMOVE_ACTIVE_FILTERS,
            `${scrollCTPafterMyFit}`,
        )]: (state: ActiveFiltersReducerStateType): ActiveFiltersReducerStateType => ({
            ...state,
            isDirty: true,
        }),
    },
    initialState,
);
